import {ExpandedState, Updater, createColumnHelper} from '@tanstack/react-table'
import {CardsWidget7} from '../../../../_metronic/partials/widgets'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import SVG from 'react-inlinesvg'
import {Link} from 'react-router-dom'

interface TrialBalance {
  voucherType?: string
  group?: string
  groupId?: number
  subGroup?: string | null
  ledger?: string
  ledgerId?: number
  credit: string | null
  debit: string | null
  children?: TrialBalance[]
}

const columnHelper = createColumnHelper<TrialBalance>()

const getTrialBalanceColumns = (
  totals: {
    differenceAmount: string
    totalDebit: string
    totalCredit: string
  },
  from?: string,
  to?: string
) => [
  columnHelper.accessor('voucherType', {
    header: ({table}) => {
      // Check if any top-level rows are expanded
      // const topLevelRows = table.getRowModel().rows.filter((row) => row.depth === 0)
      // const areAnyTopLevelExpanded = topLevelRows.some((row) => row.getIsExpanded())

      return (
        <div className='px-3 d-flex align-items-center justify-content-between min-w-125px max-w-125px'>
          <span>Classification</span>
          {/* <button
            className='btn btn-sm btn-icon btn-light-primary ms-2'
            onClick={() => {
              // Create a new expanded state object
              const newExpandedState: Record<string, boolean> = {}

              // Set all top-level rows to either expanded or collapsed based on current state
              topLevelRows.forEach((row) => {
                newExpandedState[row.id] = !areAnyTopLevelExpanded
              })

              // Apply the new expanded state
              table.setExpanded(newExpandedState)
            }}
            title={
              areAnyTopLevelExpanded ? 'Collapse all classifications' : 'Expand all classifications'
            }
          >
            <KTIcon iconName={areAnyTopLevelExpanded ? 'up' : 'down'} className='fs-2' />
          </button> */}
        </div>
      )
    },
    cell: ({row, getValue}) => {
      return (
        getValue() && (
          <div
            className='d-flex align-items-center min-w-125px max-w-125px px-3 text-dark'
            style={{
              fontSize: '14px',
              fontWeight: '800',
            }}
          >
            {row.depth === 0 ? (
              <span
                {...{
                  onClick: (e) => {
                    e.stopPropagation()
                    row.toggleExpanded()
                  },
                  style: {cursor: 'pointer'},
                  className: 'align-self-end',
                }}
              >
                {row.getIsExpanded() ? (
                  <KTIcon iconName='up' className='text-dark' />
                ) : (
                  <KTIcon iconName='down' className='text-dark' />
                )}
              </span>
            ) : (
              <></>
            )}
            {getValue()}
          </div>
        )
      )
    },
  }),
  columnHelper.accessor('group', {
    header: () => <span className='min-w-125px max-w-125px'>Group</span>,
    cell: ({row, getValue}) => {
      return (
        <span className='min-w-125px max-w-125px d-flex align-items-start text-hover-primary'>
          {row.original.children && row.original.children.length > 0 ? (
            <>
              {row.getCanExpand() && row.original.children && (
                <>
                  {row.depth === 1 && (
                    <span
                      {...{
                        onClick: (e) => {
                          e.stopPropagation()
                          row.toggleExpanded()
                        },
                        style: {cursor: 'pointer'},
                        className: 'align-self-end',
                      }}
                    >
                      {row.getIsExpanded() ? (
                        <KTIcon iconName='up' className='text-dark' />
                      ) : (
                        <KTIcon iconName='down' className='text-dark' />
                      )}
                    </span>
                  )}
                </>
              )}
            </>
          ) : (
            <span className='ms-6'></span>
          )}

          <Link
            to={`/transactions/trial-balance/group?group_id=${
              row.original.groupId || null
            }&from=${from}&to=${to}`}
            className='text-dark text-hover-primary'
            style={{
              fontSize: '13px',
              fontWeight: '700',
            }}
          >
            {getValue()}
          </Link>
        </span>
      )
    },
  }),
  columnHelper.accessor('subGroup', {
    header: () => <span className='min-w-125px'>Sub Group</span>,
    cell: ({row, getValue}) => {
      // // console.log(row.original.groupId)
      return (
        <div className='min-w-125px d-flex align-items-start text-hover-primary'>
          {row.original.children && row.original.children.length > 0 ? (
            <>
              {row.getCanExpand() && row.original.children && (
                <>
                  {row.depth === 2 && (
                    <span
                      {...{
                        onClick: (e) => {
                          e.stopPropagation()
                          row.toggleExpanded()
                        },
                        style: {cursor: 'pointer'},
                        className: 'align-self-end',
                      }}
                    >
                      {row.getIsExpanded() ? (
                        <KTIcon iconName='up' className='text-dark' />
                      ) : (
                        <KTIcon iconName='down' className='text-dark' />
                      )}
                    </span>
                  )}
                </>
              )}
            </>
          ) : (
            <span className='ms-5'></span>
          )}
          {/* <a
            href={`/transactions/trial-balance/group?parent_group=${
              row.getParentRow()?.original.group
            }&sub_group=${getValue()}&from=${from}&to=${to}`}
            className='text-dark fw-semibold text-hover-primary'
          >
            {getValue()}
          </a> */}
          <Link
            to={`/transactions/trial-balance/group?group_id=${row.original.groupId}&from=${from}&to=${to}`}
            className='text-dark text-hover-primary'
            style={{
              fontSize: '13px',
              fontWeight: '500',
            }}
          >
            {getValue()}
          </Link>
        </div>
      )
    },
  }),
  columnHelper.accessor('ledger', {
    header: () => <span className='min-w-125px'>Ledger</span>,
    cell: ({row, getValue}) => {
      // console.log(row)
      let className = ''
      if (row.depth === 3) {
        className = `text-hover-primary`
        let url = `/transactions/trial-balance/ledger?ledgerId=${row.original.ledgerId}&from=${from}&to=${to}`
        return (
          <div className='d-flex align-items-start min-w-125px text-hover-primary'>
            {row?.original?.children && row?.original?.children.length > 0 && (
              <span
                {...{
                  onClick: (e) => {
                    e.stopPropagation()
                    row.toggleExpanded()
                  },
                  style: {cursor: 'pointer'},
                  className: 'align-self-end',
                }}
              >
                {row.getIsExpanded() ? (
                  <KTIcon iconName='up' className='text-dark' />
                ) : (
                  <KTIcon iconName='down' className='text-dark' />
                )}
              </span>
            )}
            <Link
              to={url}
              className={className}
              style={{
                fontSize: '12px',
                fontWeight: '500',
                color: '#343541',
              }}
            >
              {getValue()}
            </Link>
          </div>
        )
      }
      if (row.depth === 4) {
        className = `text-hover-primary px-3 ps-8`
        let url = `/transactions/trial-balance/ledger?ledgerId=${row.original.ledgerId}&from=${from}&to=${to}`
        return (
          <Link
            to={url}
            className={className}
            style={{
              fontSize: '10px',
              fontWeight: '500',
              color: '#444654',
            }}
          >
            <em>{getValue() || `${row.getParentRow()?.original.ledger} (Parent)`}</em>
          </Link>
        )
      }
      // const parentRow = row.getParentRow()

      // const ledger = getValue()
      // if (ledger && ledger.includes('-')) {
      //   const [parent_ledger, sub_ledger] = ledger.split('-')
      //   url += `&parent_ledger=${parent_ledger.trim()}&sub_ledger=${sub_ledger.trim()}`
      // } else url += `&parent_ledger=${ledger}`
      return null
    },
    footer: () => {
      return (
        <CardsWidget7
          className='border border-dashed border-gray-300'
          stats={totals.differenceAmount}
          description='Difference'
          diff_per={
            (Math.abs(
              Number(totals.totalDebit.replace(/,/g, '')) -
                Number(totals.totalCredit.replace(/,/g, ''))
            ) /
              Math.max(
                Number(totals.totalDebit.replace(/,/g, '')),
                Number(totals.totalCredit.replace(/,/g, ''))
              )) *
            100
          }
        />
      )
    },
  }),
  columnHelper.accessor('debit', {
    header: () => <span className='min-w-125px'>Debit</span>,
    cell: ({row, table}) => (
      <>
        {row.depth > 0 ? (
          <div
            className={
              row.depth === 1
                ? 'text-dark'
                : row.depth === 2
                ? 'text-dark'
                : row.depth === 3
                ? ''
                : 'ki-text-italic'
            }
            style={{
              textAlign: 'right',
              width: '100%',

              fontSize:
                row.depth === 1
                  ? '13px'
                  : row.depth === 2
                  ? '13px'
                  : row.depth === 3
                  ? '12px'
                  : '10px',

              fontWeight:
                row.depth === 1 ? '700' : row.depth === 2 ? '500' : row.depth === 3 ? '500' : '500',
              color: row.depth === 3 ? '#343541' : row.depth > 3 ? '#444654' : '',
              fontStyle: row.depth > 3 ? 'italic' : 'normal',
            }} // Added text-align: right;
          >
            {row.original.debit ?? '-'}
          </div>
        ) : (
          <span
            // onClick={() => table.setExpanded({'0': true, '1': true, '2': true, '3': true})}
            style={{cursor: 'pointer', textAlign: 'right', width: '100%', display: 'block'}}
          >
            {/* <i className='bi bi-dash-circle-fill fs-1 text-dark' /> */}
          </span>
        )}
      </>
    ),
    footer: () => (
      <CardsWidget7
        className='border border-dashed border-gray-300'
        stats={totals.totalDebit}
        description='Total Debits'
      />
    ),
  }),
  columnHelper.accessor('credit', {
    header: () => <span className='min-w-125px'>Credit</span>,
    cell: ({row, table}) => (
      <>
        {row.depth > 0 ? (
          <div
            className={
              row.depth === 1
                ? 'text-dark'
                : row.depth === 2
                ? 'text-dark'
                : row.depth === 3
                ? ''
                : 'ki-text-italic'
            }
            style={{
              textAlign: 'right',
              width: '100%',

              fontSize:
                row.depth === 1
                  ? '13px'
                  : row.depth === 2
                  ? '13px'
                  : row.depth === 3
                  ? '12px'
                  : '10px',

              fontWeight:
                row.depth === 1 ? '700' : row.depth === 2 ? '500' : row.depth === 3 ? '500' : '500',
              color: row.depth === 3 ? '#343541' : row.depth > 3 ? '#444654' : '',
              fontStyle: row.depth > 3 ? 'italic' : 'normal',
            }}
          >
            {row.original.credit ? row.original.credit : '-'}
          </div>
        ) : (
          <span
            onClick={() => {
              const exp: Updater<ExpandedState> = table.getState().expanded as Record<
                string,
                boolean
              >
              row.subRows.map((s) => {
                exp[s.id] = true

                s.subRows.map((s1) => {
                  exp[s1.id] = true

                  s1.subRows.map((s2) => {
                    exp[s2.id] = true
                    return null
                  })
                  return null
                })

                return null
              })
              exp[row.id] = false
              table.setExpanded(exp)
              row.toggleExpanded()
            }}
            style={{cursor: 'pointer', textAlign: 'right', width: '100%', display: 'block'}}
          >
            {/* <i className='bi bi-plus-circle-fill fs-1 text-dark' /> */}
          </span>
        )}
      </>
    ),
    footer: () => (
      <CardsWidget7
        className='border border-dashed border-gray-300'
        stats={totals.totalCredit}
        description='Total Credits'
      />
    ),
  }),
]

export {getTrialBalanceColumns}
